var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show())?_c('div',{staticClass:"leaderboard__close-tournament-button"},[_c('button',{staticClass:"button button-primary",on:{"click":function($event){$event.preventDefault();return _vm.close.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t('Close tournament'))+" ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }